<ng-container *ngIf="workflowResult === workflowResults.successful">
  <a href="" (click)="downloadContent($event)">{{ 'LINK_TO_PDF' | translate }}</a>
</ng-container>
